import PropTypes from "prop-types";
import MDBox from "components/MDBox";

function DataTableConfigHeadCell({ children, align,isFirst, isLast  }) {
    return (
        <MDBox
            component="th"
            textAlign={align}
            py={1}
            px={3}
            sx={({ typography, palette }) => ({
                backgroundColor: "#3C96EF", // 🎯 Your custom blue
                color: palette.white.main,
                fontSize: typography.size.sm,
                fontWeight: typography.fontWeightBold,
                whiteSpace: "nowrap",
                height: "39px",
                borderBottom: `1px solid ${palette.grey[300]}`,
                borderTopLeftRadius: isFirst ? "12px" : 0,
                borderTopRightRadius: isLast ? "12px" : 0,
            })}
        >
            {children}
        </MDBox>
    );
}

DataTableConfigHeadCell.defaultProps = {
    align: "left",
    isFirst: false,
    isLast: false,
};

DataTableConfigHeadCell.propTypes = {
    children: PropTypes.node.isRequired,
    align: PropTypes.oneOf(["left", "center", "right"]),
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
};

export default DataTableConfigHeadCell;
